<template>
  <FormGroup
    :label="label"
    :input-id="idCalc"
    :errors="errorsCalc"
    :successes="successes"
    class="w-100"
  >
    <table class="m4 package-selection">
      <tr class="package-list-header">
        <th>
          <Logo class="mx-auto" :logo="appType" :size="40" />
          <div class="mx-auto text-capitalize mb-2">{{ appName }}</div>
        </th>
        <td class="price" v-for="(pack, i) in packages" :key="i">
          <div class="package-name">{{ pack.name }}</div>
          <div class="text-capitalize text-primary">
            <span class="fee">{{ getPrice(term, pack) }}</span> /
            <span class="term">{{ term }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <th>{{ $t("global.sites") }}</th>
        <td :class="{ selected: isSelected(pack) }" v-for="(pack, i) in packages" :key="i">
          <span>{{ pack.cloudAccounts }}</span>
        </td>
      </tr>
      <tr>
        <th>{{ $t("global.backups") }}</th>
        <td :class="{ selected: isSelected(pack) }" v-for="(pack, i) in packages" :key="i">
          {{ $t("global.days", { count: 30 }) }}
        </td>
      </tr>
      <tr>
        <th>{{ $t("global.disk-space") }}</th>
        <td :class="{ selected: isSelected(pack) }" v-for="(pack, i) in packages" :key="i">
          {{ fromGBFormat(pack.diskSpace) }}
        </td>
      </tr>
      <tr>
        <th>{{ $t("global.bandwidth") }}</th>
        <td :class="{ selected: isSelected(pack) }" v-for="(pack, i) in packages" :key="i">
          {{ fromGBFormat(pack.bandwidth) }}
        </td>
      </tr>
      <tr>
        <th>{{ $t("global.email-accounts") }}</th>
        <td :class="{ selected: isSelected(pack) }" v-for="(pack, i) in packages" :key="i">
          {{ $t("global.unlimited") }}
        </td>
      </tr>
      <tr class="package-list-footer">
        <th></th>
        <td v-for="(pack, i) in packages" :key="i">
          <Btn :variant="variant(pack)" size="default" @click="select(pack)">
            {{ $t("global.select") }}
          </Btn>
        </td>
      </tr>
    </table>
  </FormGroup>
</template>
<script>
import Btn from "@/components/display/Btn";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";
import { fromGBFormat } from "leatherman-js/utils/formatters/size";
import Logo from "@/components/display/Logo";
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import { ref } from "@vue/composition-api";

export default {
  name: "FormPackageCheckoutSelect",
  components: {
    Btn,
    Logo,
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    value: Number,
    appType: String,
    appName: String,
    appId: Number,
    packages: {
      validator: (value) => {
        if (!Array.isArray(value)) {
          return false;
        }
        return value;
      },
    },
    term: {
      validator: (value) => ["monthly", "annually"].includes(value),
    },
  },
  setup(props, { emit }) {
    const selectedPackage = ref(props.value);

    const isSelected = (pack) => {
      return String(selectedPackage.value) === String(pack.id);
    };

    const getPrice = (term, pack) => {
      if (term === "monthly") {
        return moneyFormat(pack.monthlyFee + pack.appPricing[props.appId]);
      } else {
        return moneyFormat(pack.annualFee);
      }
    };
    const select = (pack) => {
      selectedPackage.value = pack.id;
      emit("input", pack.id);
    };

    const variant = (pack) => {
      return isSelected(pack) ? "primary" : "light";
    };

    return { fromGBFormat, select, isSelected, getPrice, variant };
  },
};
</script>
<style lang="scss" scoped>
.price {
  .package-name {
    text-transform: uppercase;
    font-size: 12px;
  }
  .fee {
    font-size: 16px;
    font-weight: bold;
  }

  .term {
    font-size: 12px;
    font-weight: normal;
  }
}

.package-selection {
  width: 100%;

  .app-logo > img {
    width: 50%;
  }

  th,
  td {
    max-width: 90px;
    text-align: center;
    height: 70px;
    border-collapse: collapse;
  }

  .package-list-header > th,
  .package-list-header > td,
  .package-list-footer > th,
  .package-list-footer > td {
    border: none;
  }
}
</style>
